/*
 * MySiteCare
 *
 * Copyright © 2026 Jeanjen Sisoy Luberio
 * doing business as MySiteCare Website Application Services.
 * All rights reserved.
 *
 * DTI Business Name No. 7934250
 * https://mysitecare.eu
 *
 * This file contains original proprietary MySiteCare source code,
 * except for third-party components identified under their
 * respective licenses.
 */
// INTERNAL TEST FIXTURE (Phase C repair-pipeline demonstration) — deliberately
// mounts RepairCanaryComponent with no `user` prop so a real page load throws a real,
// reproducible browser error. Never linked from any real navigation; unauthenticated
// only because it is harmless (a blank test card, no data, no mutation) — matching
// the same "deliberate, permanent, admin-adjacent test utility" precedent as the
// backend's own /api/admin/test-monitoring/trigger-500.
import RepairCanaryComponent from "./RepairCanaryComponent";

export default function RepairCanaryPage() {
  return (
    <div style={{ padding: 40 }}>
      <h1>Repair Canary (internal test fixture)</h1>
      <RepairCanaryComponent />
    </div>
  );
}
